import { useSelector } from "react-redux";

export function useArchivedAdvisorLists() {
  return useSelector((state) => state.archivedAdvisorLists);
}
